"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductsService;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icons = require("./Icons");
var _useIsMobileState3 = require("./useIsMobileState");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-no-target-blank */
// require('./index.scss');

const DEFAULT_URL = 'https://www.tencentcloud.com/';
const arrayGenerator = (length, generator) => {
  const array = [];
  let i = 0;
  while (i < length) {
    array.push(generator(i));
    i += 1;
  }
  return array;
};

/**
 * 定价产品服务介绍组件
 * @props.style  { backgroundColor: "#fff" }
 * @props.title "产品服务"
 * @props.list [{
          title: "Cloud Virtual Machine",
          logo: "https://main.qcloudimg.com/raw/860a531bada396bb3c0670c615cee34d.svg",
          intro_list: [
            {
              title: "CPU",
              text: "1 水电费水电费是否",
              link: "https://learn.woa.com",
              hasCalculator: true,
            },
          ],
        }]
 */
function ProductsService(props) {
  const _useIsMobileState = (0, _useIsMobileState3.useIsMobileState)(),
    _useIsMobileState2 = (0, _slicedToArray2.default)(_useIsMobileState, 1),
    isMobile = _useIsMobileState2[0];
  const _useState = (0, _react.useState)(-1),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeItemIndex = _useState2[0],
    setActiveItemIndex = _useState2[1];
  const title = props.title,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list;
  const rows = Math.ceil(list.length / 5);
  (0, _react.useEffect)(() => {
    setActiveItemIndex(isMobile ? -1 : 0);
  }, [isMobile]);
  const onClickItem = item => {
    const index = list.indexOf(item);
    setActiveItemIndex(index === activeItemIndex ? -1 : index);
  };
  const buildGroup = (row, group) => {
    const showIntro = activeItemIndex > -1 && Math.floor(activeItemIndex / 5) === row;
    let intro = [];
    if (showIntro) {
      intro = list[activeItemIndex].intro_list;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `group-${row}`
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "pricing-products-group"
    }, group.map((item, indx) => {
      const index = row * 5 + indx;
      return [/*#__PURE__*/_react.default.createElement("li", {
        key: `item-${index}`,
        onClick: () => onClickItem(item),
        className: `${activeItemIndex === index ? 'product-active' : ''}`
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "pricing-product-logo",
        src: item.logo,
        alt: item.title
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "pricing-product-title"
      }, item.title), !isMobile && activeItemIndex === index ? /*#__PURE__*/_react.default.createElement("div", {
        className: "pricing-arrow-up"
      }) : null, isMobile ? (0, _Icons.ArrowUpDownIcon)(activeItemIndex === index) : null), isMobile && activeItemIndex === index ? /*#__PURE__*/_react.default.createElement("ul", {
        className: "pricing-mobile-intro-box",
        key: `ul-${index}`
      }, intro.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
        key: `intro-${index}`
      }, /*#__PURE__*/_react.default.createElement("a", {
        target: "_blank",
        href: item.link || DEFAULT_URL
      }, /*#__PURE__*/_react.default.createElement("h4", null, item.title, item.hasCalculator ? /*#__PURE__*/_react.default.createElement("i", {
        className: "svg-cal",
        alt: "calculator"
      }, (0, _Icons.CalculatorIcon)()) : null), /*#__PURE__*/_react.default.createElement("p", null, item.text))))) : null];
    }), !isMobile && arrayGenerator(5 - group.length, indx => /*#__PURE__*/_react.default.createElement("li", {
      key: `empty-${group.length + indx}`,
      className: "pricing-empty-li"
    }))), !isMobile && showIntro ? /*#__PURE__*/_react.default.createElement("div", {
      className: "pricing-intro-box-wrapper"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "pricing-intro-box"
    }, intro.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      target: "_blank",
      href: item.link || DEFAULT_URL
    }, /*#__PURE__*/_react.default.createElement("h4", null, item.title, item.hasCalculator ? /*#__PURE__*/_react.default.createElement("i", {
      className: "svg-cal"
    }, (0, _Icons.CalculatorIcon)()) : null), /*#__PURE__*/_react.default.createElement("p", null, item.text)))))) : null);
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: 'pricing-products-service-box',
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pricing-products-service-body"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "pricing-products-service-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "pricing-products-list"
  }, arrayGenerator(rows, i => buildGroup(i, list.slice(5 * i, 5 * i + 5))))));
}